export const negotiationStatusName = 'Negociação';

export const scheduleTypes = {
    meeting: 'meeting',
    purchaseDate: 'purchase_date',
};

export const scheduleOutcomes = {
    willBuy: 'will_buy',
    needsConversation: 'needs_conversation',
};

// De onde o vendedor agendou, cancelou ou concluiu: vai para o histórico só para monitorar.
export const scheduleOrigins = {
    detailHeader: 'DETAIL_HEADER',
    detailMenu: 'DETAIL_MENU',
    detailBanner: 'DETAIL_BANNER',
    detailActivity: 'DETAIL_ACTIVITY',
    detailCallDrawer: 'DETAIL_CALL_DRAWER',
    detailMessageDrawer: 'DETAIL_MESSAGE_DRAWER',
    agendaCard: 'AGENDA_CARD',
    agendaCallDrawer: 'AGENDA_CALL_DRAWER',
    agendaMessageDrawer: 'AGENDA_MESSAGE_DRAWER',
};

export const scheduleTypeOptions = [
    {
        key: scheduleTypes.meeting,
        label: 'Reunião',
        description: 'Ligação combinada com o cliente.',
    },
    {
        key: scheduleTypes.purchaseDate,
        label: 'Data da compra',
        description: 'Dia em que o cliente disse que vai comprar.',
    },
];

export const scheduleOutcomeOptions = [
    {
        key: scheduleOutcomes.willBuy,
        label: 'Vai comprar',
        description: 'Agende a data e a hora em que o cliente disse que compra.',
    },
    {
        key: scheduleOutcomes.needsConversation,
        label: 'Precisa de mais conversa',
        description: 'A cadência volta no próximo dia útil.',
    },
];

const scheduleShortLabels = {
    [scheduleTypes.meeting]: 'Reunião',
    [scheduleTypes.purchaseDate]: 'Compra',
};

const scheduleLongLabels = {
    [scheduleTypes.meeting]: 'Reunião agendada',
    [scheduleTypes.purchaseDate]: 'Compra combinada',
};

export const scheduleTexts = {
    operationLabel: 'Agendar',
    drawerActionLabel: 'Agendar atendimento',
    cancelOperationLabel: 'Cancelar agendamento',
    cancelSuccessMessage: 'Agendamento cancelado. A cadência volta para hoje.',
    cancelConfirmationTitle: 'Cancelar o agendamento?',
    cancelConfirmationDescription: 'A cadência volta para a agenda de hoje. O agendamento cancelado conta no limite de 2 por oportunidade.',
    modalTitle: 'Agendar atendimento',
    modalDescription: 'Até o horário marcado, a oportunidade sai da agenda e nenhum processo automático mexe nela.',
    typeLabel: 'O que foi combinado',
    dateLabel: 'Data',
    timeLabel: 'Horário',
    submitLabel: 'Agendar',
    submittingLabel: 'Agendando...',
    cancelLabel: 'Cancelar',
    successMessage: 'Atendimento agendado.',
    loadConfigError: 'Não foi possível carregar os limites do agendamento.',
    retryLabel: 'Tentar novamente',
    getLimitHint: (maxDaysAhead, maxPerOpportunity) =>
        `Até ${maxDaysAhead} dias a partir de hoje, em dia útil. Limite de ${maxPerOpportunity} agendamentos por oportunidade.`,
    conclusionTitle: 'Concluir atendimento agendado',
    conclusionDescription: 'Conte o que aconteceu. O resultado fica no histórico da oportunidade.',
    outcomeLabel: 'Resultado',
    getLimitReachedConclusionNotice: (maxPerOpportunity) =>
        `Esta oportunidade já usou os ${maxPerOpportunity} agendamentos, então não dá para marcar a data da compra. Ao concluir, a cadência volta no próximo dia útil.`,
    nextDateLabel: 'Data da compra',
    nextTimeLabel: 'Horário',
    messageLabel: 'Como foi o atendimento',
    messagePlaceholder: 'Ex.: o cliente gostou da proposta e pediu o boleto para sexta.',
    getMessageCounter: (length, minimum) => `${length}/${minimum} caracteres mínimos`,
    conclusionSubmitLabel: 'Concluir',
    conclusionSubmittingLabel: 'Concluindo...',
    conclusionSuccessMessage: 'Atendimento concluído.',
    stripTitle: 'Agendados',
    getChipLabel: (scheduleType, time, dayLabel) =>
        `${scheduleShortLabels[scheduleType] || 'Agendamento'}${dayLabel ? ` ${dayLabel}` : ''} às ${time}`,
    getWaitingNotice: (scheduleType, time, dayLabel) =>
        `${scheduleLongLabels[scheduleType] || 'Atendimento agendado'} para ${dayLabel ? `${dayLabel} às` : 'as'} ${time}. Conclua pelo botão Concluir, com o resultado.`,
    yesterdayLabel: 'ontem',
    tomorrowLabel: 'amanhã',
    getShortLabel: (scheduleType) => scheduleShortLabels[scheduleType] || 'Agendamento',
    getBannerTitle: (scheduleType, when) => `${scheduleLongLabels[scheduleType] || 'Atendimento agendado'} para ${when}`,
    getBlockedReason: (scheduleType, when) => `${scheduleLongLabels[scheduleType] || 'Atendimento agendado'} para ${when}.`,
};
